import { NavLink } from "react-router-dom";

const ErrorPage = () => {
    return (
        <div className="mx-auto max-w-screen-xl flex flex-col items-center justify-center h-screen">
            <div className="mx-auto max-w-screen-sm text-center">
                <h1 className="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-blue-normal">404</h1>
                <p className="mb-4 text-3xl tracking-tight font-bold text-sky-normal md:text-4xl">Something's missing.</p>
                <p className="mb-4 text-lg font-light text-blue-disable">Sorry, we can't find that page. You'll find lots to explore on the home page. </p>
                <NavLink to="/orders" className="inline-flex text-white bg-blue-normal focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center my-4">Back to Home</NavLink>
            </div>   
        </div>
    )
}

export default ErrorPage;